module.exports = __webpack_public_path__ + "build/assets/STIXTwoText-BoldItalic-d1f61df64be64530828b781d709b57b9.woff2";